import styled from 'styled-components';

export const StyledBulletPoint = styled.div`
    display: flex;
`;

export const Marker = styled.div`
    width: 35px;
    height: 35px;
    background-color: rgb(68,142,148);
    display:flex;
    justify-content: center;
    align-items: center;
    border-radius: 50px;
    font-size: 22px;
`;

export const MarkerText = styled.span`
    color:white;
    font-weight: bold;
`;

export const TextContainer = styled.div`
    padding: 5px 20px;
    flex:1;
`;

export const Heading = styled.h4`
    font-weight: bold;
`;